import { IModel, Collection } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { SingleStreamOutputTransformation } from 'app/model/dataflow/single-output-stream.transformation';
import { SortExpression, ISortableTransformation } from './sort-expression';
import { format } from '../../shared/utils/string.util';
import { DataFlowExpression } from './dataflowexpression';
import { Owned } from '../base/named';
import { IExtraFieldInfo } from 'app/interfaces/IExtraFieldInfo';
import { DataFlowColumn } from '../dataset/dataflowcolumn';
import { BooleanDataFlowType } from './dataflow-datatype';

@Metamodel.model({
    name: 'basesorttransformation', // As this is abstract this will never be used
    abstract: true
})
export abstract class BaseSortTransformation extends SingleStreamOutputTransformation implements ISortableTransformation {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        type: SortExpression.MODEL,
        collection: Collection.Array,
        constraint: {
            minOccurs: 1,
            unique: true,
            validator: SortExpression.validateExpressions
        }
    })
    public sortExpressions: SortExpression[] = [];

    public inspectDetailsOutputFields: IExtraFieldInfo[] = [
        {
            name: () => stringResources.TransformationInspect_Column_Ordered,
            icon: this._isAscending.bind(this)
        }
    ];

    public caseInsensitive: DataFlowExpression = this.createTemplatableExpression(BooleanDataFlowType.TYPE, 'false');

    public addSortExpression(): SortExpression {
        const sortExpression = Owned.create<SortExpression>(SortExpression.MODEL, this);
        sortExpression.ascending = true;
        sortExpression.nullsFirst = true;
        this.sortExpressions.push(sortExpression);
        return sortExpression;
    }

    public getExpressions(): DataFlowExpression[] {
        return this.sortExpressions
            .filter((sortExpression) => sortExpression.dataFlowExpression)
            .map((sortExpression) => sortExpression.dataFlowExpression);
    }

    protected updateInputTransformationCacheInternal(): void {
        SortExpression.updateSortExpressionIdentifiers(this.sortExpressions, this.distinctInputColumnRefs, this.dataflow.parameters, this.dataflow.cacheSinks, this);
    }

    protected _getGeneratedDescriptionInteral(sortDescription: string, emptySortDescription: string): string {
        if (this.sortExpressions.length > 0) {
            const columnNames: string[] = [];
            this.sortExpressions.forEach((sortExpression) => {
                if (sortExpression.dataFlowExpression) {
                    columnNames.push(...sortExpression.dataFlowExpression.argumentsUsed.dataFlowColumns.map((dataFlowColumn) => dataFlowColumn.column.name));
                }
            });
            if (columnNames.length) {
                return format(sortDescription, columnNames.join(', '));
            }
        }
        return emptySortDescription;
    }

    protected _isAscending(column: DataFlowColumn): string {
        const sortExpression = this.sortExpressions.find((e) => e.dataFlowExpression.expression === column.name);
        return !sortExpression || sortExpression.ascending === null ? '-' : sortExpression.ascending ? 'svg-sort-arrow-up' : 'svg-sort-arrow-down';
    }
}
